
export default {
  name: 'ToastPanel',

  props: {
    dense: Boolean,

    labelClose: {
      type: String,
      required: true
    }
  },

  computed: {
    placement() {
      const [vertical, horizontal] = this.$toast.placement.split('-')

      return {
        top: vertical === 'top',
        bottom: vertical === 'bottom',
        left: horizontal === 'left',
        right: horizontal === 'right'
      }
    }
  }
}
